module.exports = __webpack_public_path__ + "static/img/sport_bg5.f0f7602a.jpg";